import React, {useState} from "react";
import {Card, CardBody, Modal, ModalBody, ModalHeader} from "reactstrap";
import Input from "../EditElement/Input";
import {BASE_URL} from "../../config";
import {setUserData} from "../../services/fetcher";
import {any} from "prop-types";
import {toastError} from "../../utils/ToastConfig";

export default function CustomModalDoubleAuthFactor(props) {
    const {toggle, open, accessData, username, message} = props;

    const [value, setValue] = useState();
    const handleChange = ({target: {value}}) => {
        setValue(value);
    }

    const onSubmit = async () => {
        const token = accessData.access;
        const params = {
            method: 'POST',
            body: JSON.stringify({code: value?.trim() ?? '', username: username}),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }
        };
        try {
            const response = await fetch(`${BASE_URL}/persons/double-factor/check-code/`, params);
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            setUserData(accessData);
        } catch (e) {
            console.log(e);
            toastError('Código incorrecto o expirado');
        }
    };

    return (
        <Modal size="sm" toggle={toggle} isOpen={open} className="persona">
            <ModalHeader toggle={toggle} charCode="x"></ModalHeader>
            <ModalBody>
                <Card>
                    <CardBody>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}>
                            <h2 style={{textAlign: "center"}}>
                                {message}
                            </h2>
                            <Input inputStyle={{width: 350}} value={value} onChange={handleChange}/>
                            <div style={{display: "flex", justifyContent: "space-between", marginTop: 20}}>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    style={{flex: 1, marginRight: 10, width: 250}}
                                    onClick={onSubmit}
                                >
                                    Enviar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    style={{flex: 1, marginLeft: 10, width: 250}}
                                    onClick={toggle}
                                >
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </ModalBody>
        </Modal>
    );
}

CustomModalDoubleAuthFactor.defaultProps = {
    toggle: () => {
    },
    accessData: any
};
